import React, { useEffect, useRef, useState } from 'react'
import useSound from 'use-sound'

import neomplot from '../../../assets/sounds/neomplot.mp3'
import rainbowplot from '../../../assets/sounds/rainbowplot.mp3'
import onicplot from '../../../assets/sounds/onicplot.mp3'
import thebitplot from '../../../assets/sounds/thebitplot.mp3'
import message3 from '../../../assets/sounds/message3.mp3'

// 기존 모의신청 + 가입신청 -> 변경 SoundRepeat3 : 모의신청 , SoundRepeat6 : 가입신청
const SoundRepeat3 = ({text=''}) => { 

//	const [bell, setBell] = useState<string | null>(null);
	const [refresh, setRefresh] = useState(false);

	// useEffect(() => {
	// 	const loadSound = async () => {
	// 	  let sound;
	// 	  if (process.env.REACT_APP_NAME === 'NEOM') {
	// 		sound = await import('../../../assets/sounds/neomplot.mp3');
	// 	  } else if (process.env.REACT_APP_NAME === 'RAINBOW') {
	// 		sound = await import('../../../assets/sounds/rainbowplot.mp3');
	// 	  } else if (process.env.REACT_APP_NAME === 'ONIC') {
	// 		sound = await import('../../../assets/sounds/onicplot.mp3');
	// 	  } else { // 기본
	// 		sound = await import('../../../assets/sounds/message3.mp3'); // 다른 경로 예시
	// 	  }
	// 	  setBell(sound.default);
	// 	};
	
	// 	loadSound();
	//   }, []);

	let bell = message3
	if (process.env.REACT_APP_NAME === 'NEOM') {
		bell = neomplot
	 } else if (process.env.REACT_APP_NAME === 'RAINBOW') {
	   bell = rainbowplot;
	 } else if (process.env.REACT_APP_NAME === 'ONIC') {
	   bell = onicplot
	 }  else if( process.env.REACT_APP_NAME === 'THEBIT') {
	   bell = thebitplot
	 }else { // 기본
	   bell =  message3
	 }
	 console.log("SOUND", process.env.REACT_APP_NAME);

	  
	const [play, { stop }] = useSound(bell || '', { interrupt: true,volume:process.env.REACT_APP_NAME === 'ONIC'?0.6:1  });

	useEffect(() => {
		  console.log("PLAY3");
		  play({
			forceSoundEnabled: true,
		  });
		  setTimeout(() => {
			setRefresh(!refresh);
		  }, 60*1000*5);
	  }, [refresh]);
	
	  useEffect(() => {
		setTimeout(() => {
		  setRefresh(!refresh);
		}, 200);
	
		return () => {
		  stop();
		};
	  }, [stop]);

	return <>{''}</>
}
export default SoundRepeat3
